import { Box, CircularProgress } from "@mui/material"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export default function ErrorRoutePageHandler() {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(()=>{
        navigate(location.pathname)
    },[])

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
    </Box>
  )
}
